// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: Заменить any на конкретный тип
import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { API_ENDPOINT } from 'api/constants';
import TrackingAPI from 'api/TrackingAPI';
import void_ava from 'assets/mask.svg';
import axios from 'axios';
import Carousel from 'components/Carousel';
import MediaPackCard from 'components/characters/MediaPackCard/MediaPackCard';
import CarouselPictureModal from 'modals/CarouselPictureModal/CarouselPictureModal';
import { useMappedState } from 'redux-react-hook';
import styled from 'styled-components';
import Spinner from 'ui-kit/Spinner';

interface Character {
  name: string;
  publicInfo: {
    age?: string;
    gender?: string;
    personality?: string;
  };
  characterMediaIds: string[];
  avatarsMap: {
    default?: string;
    [key: string]: string | undefined;
  };
  mediaPacks?: {
    id: string;
    coverUrl: string;
    title: string;
    mediaItems?: string[];
    type: string;
  }[];
}

interface MediaItem {
  id: string;
  url: string;
  videoUrl?: string;
  isObscene: boolean;
  isBlurred: boolean;
  isVideo: boolean;
}

enum CharacterTabs {
  GALLERY = 'gallery',
  ABOUT = 'about'
}

interface ITransformedMediaItem {
  id: number;
  url: string;
  type: string;
}

interface CharacterGalleryProps {
  analyticsData: {
    config_name?: string;
    scenario_name?: string;
    dialogId?: string;
  };
  characters: Character[];
  setIsSubscriptionModalOpen: () => void;
  setIsSignUpModalOpen: Dispatch<SetStateAction<boolean>>;
  setIsEmailConfirmationModalOpen: Dispatch<SetStateAction<boolean>>;
  game?: Record<string, unknown>;
  scenario?: Record<string, unknown>;
  currentUser: unknown;
}

const hasPublicInfo = (character: Character | null): boolean => {
  if (!character?.publicInfo) return false;

  return Object.values(character.publicInfo).some(
    value => value !== undefined && value !== null && value !== ''
  );
};

const hasGallery = (character: Character | null, currentUser: unknown): boolean => {
  if (!character) return false;

  const hasMediaIds = character.characterMediaIds.length > 0;
  const hasMediaPacks = character.mediaPacks && character.mediaPacks.length > 0;
  const allPacksArePaid = character.mediaPacks?.every(pack => pack.type === 'paid');

  if (hasMediaIds) return true;

  if (hasMediaPacks) {
    if (allPacksArePaid && !currentUser?.hasSubscription) return false;
    return true;
  }

  return false;
};

const CharacterAdditionalInfo: React.FC<CharacterGalleryProps> = (props) => {
  const {
    analyticsData,
    characters,
    setIsSubscriptionModalOpen,
    setIsSignUpModalOpen,
    setIsEmailConfirmationModalOpen,
    activeMobileNavigationTab,
    game,
    scenario,
    currentUser
  } = props;

  const filteredCharacters = characters.filter(character => {
    return hasPublicInfo(character) || hasGallery(character, currentUser);
  });

  if (filteredCharacters.length === 0) {
    return null;
  }


  const [mediaItems, setMediaItems] = useState<MediaItem[]>([]);
  const [isLoadingMedia, setIsLoadingMedia] = useState(false);

  const [activeCharacter, setActiveCharacter] = useState<Character | null>(filteredCharacters[0]);
  const [activeTab, setActiveTab] = useState<CharacterTabs>(
    hasPublicInfo(filteredCharacters[0]) ? CharacterTabs.ABOUT : CharacterTabs.GALLERY
  );

  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState<number | null>(null);

  const { currentUserId, hasSubscription, isEmailConfirmed } = useMappedState(
    useCallback(state => {
      const currentUserId = state.users.currentUserId;
      const currentUser = state.users.usersMap.get(currentUserId);
      const hasSubscription = !!currentUser?.hasSubscription;
      return {
        currentUserId: state.users.currentUserId,
        hasSubscription: hasSubscription,
        isEmailConfirmed: currentUser?.emailVerified
      };
    }, [])
  );

  const scenarioMediaPacks = scenario?.mediaPacks ?? [];

  const handleDragScroll = (e: React.MouseEvent<HTMLDivElement>) => {
    const ele = e.currentTarget;
    if (!ele) return;

    const pos = {
      left: ele.scrollLeft,
      x: e.clientX
    };

    const mouseMoveHandler = (e: MouseEvent) => {
      const dx = e.clientX - pos.x;
      ele.scrollLeft = pos.left - dx;
    };

    const mouseUpHandler = () => {
      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
    };

    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
  };

  const isVisiblePictureModal = selectedPhotoIndex !== null;

  const transformMediaItems = (items: MediaItem[]): ITransformedMediaItem[] => {
    const filteredMediaItemsByBlur = items.filter(item => hasSubscription || !item.isBlurred);
    return filteredMediaItemsByBlur.map((item, index) => ({
      id: item.id ?? index,
      url: item.isVideo ? item.videoUrl : item.url,
      type: item.isVideo ? 'video' : 'image',
    }));
  };

  useEffect(() => {
    const fetchCharacterMedia = async () => {
      if (!activeCharacter?.characterMediaIds.length) {
        setMediaItems([]);
        return;
      }

      setIsLoadingMedia(true);
      try {
        const pld = (
          await axios.post(`${API_ENDPOINT}/characterMedia/batch`, {
            userId: currentUserId,
            mediaIds: activeCharacter.characterMediaIds
          })
        ).data;

        setMediaItems(pld);
      } catch (errors) {

        setMediaItems([]);
        throw errors;
      } finally {
        setIsLoadingMedia(false);
      }
    };


    fetchCharacterMedia();
  }, [activeCharacter?.characterMediaIds, currentUserId]);

  useEffect(() => {
    if (activeMobileNavigationTab && isMobile) {
      setActiveCharacter(characters.find(character => character.name === activeMobileNavigationTab));
    }
  }, [activeMobileNavigationTab, isMobile]);


  const renderCharacterInfo = () => {
    return (
      <CharacterInfo>
        <InfoRow>
          <InfoItem>
            <InfoLabel>
              <IconWrapper>
                <UserIcon />
              </IconWrapper>
              Name
            </InfoLabel>
            <InfoValue>{activeCharacter?.name}</InfoValue>
          </InfoItem>
          {activeCharacter?.publicInfo.age && (
            <InfoItem>
              <InfoLabel>
                <IconWrapper>
                  <AgeIcon />
                </IconWrapper>
                Age
              </InfoLabel>
              <InfoValue>{activeCharacter.publicInfo.age}</InfoValue>
            </InfoItem>
          )}
        </InfoRow>
        {activeCharacter?.publicInfo.gender && (
          <InfoRow>
            <InfoItem>
              <InfoLabel>
                <IconWrapper>
                  <GenderIcon />
                </IconWrapper>
                Gender
              </InfoLabel>
              <InfoValue>{activeCharacter.publicInfo.gender}</InfoValue>
            </InfoItem>
          </InfoRow>
        )}
        {activeCharacter?.publicInfo.personality && (
          <InfoRow hasScenarioMediaPacks={scenarioMediaPacks.length > 0}>
            <InfoItem fullWidth>
              <InfoLabel>
                <IconWrapper>
                  <PersonalityIcon />
                </IconWrapper>
                Personality
              </InfoLabel>
              <InfoValue>{activeCharacter.publicInfo.personality}</InfoValue>
            </InfoItem>
          </InfoRow>
        )}
      </CharacterInfo>
    );
  };


  const hasVisibleMediaPacks = activeCharacter?.mediaPacks?.some(
    mediaPack => mediaPack && (mediaPack.type !== 'paid' || hasSubscription)
  );

  const renderGallery = () => {
    const hasItems = mediaItems && mediaItems.length > 0 || hasVisibleMediaPacks;

    return isLoadingMedia ? (
      <LoaderWrapper>
        <Spinner size={100} />
      </LoaderWrapper>
    ) : (
      <GalleryContainer>
        {activeCharacter?.mediaPacks && activeCharacter.mediaPacks.length > 0 && hasVisibleMediaPacks && (
          <GalleryContainerWrapper hasVisibleMediaPacks={hasVisibleMediaPacks}>
            {activeCharacter.mediaPacks.map((mediaPack, index) => (
              (mediaPack && (mediaPack.type !== 'paid' || hasSubscription)) && (
                <MediaPackCard
                  key={mediaPack.id || index}
                  mediaPack={mediaPack}
                  setIsSubscriptionModalOpen={setIsSubscriptionModalOpen}
                  setIsSignUpModalOpen={setIsSignUpModalOpen}
                  setIsEmailConfirmationModalOpen={setIsEmailConfirmationModalOpen}
                  game={game}
                  scenario={scenario}
                  characterName={activeCharacter.name}
                />
              )
            ))}
          </GalleryContainerWrapper>
        )}

        {hasItems && (
          <GalleryGrid>
            {mediaItems.map((mediaItem, index) => {
              if (!mediaItem?.url) {
                return null;
              }

              return (
                <GalleryItem
                  key={`gallery-item-${index}`}
                  onClick={() => {
                    if (!currentUserId) {
                      setIsSignUpModalOpen(true);
                      return;
                    }

                    if (!isEmailConfirmed) {
                      setIsEmailConfirmationModalOpen(true);
                      return;
                    }

                    if (!hasSubscription && mediaItem.isBlurred) {
                      setIsSubscriptionModalOpen();
                      return;
                    }

                    setSelectedPhotoIndex(index);
                  }}
                >
                  <GalleryImage src={mediaItem.url} alt="Character preview" draggable="false" />
                  {mediaItem.isVideo && <VideoIndicator />}
                  {mediaItem.isBlurred && !hasSubscription && (
                    <BlurIndicator>
                      <div>
                        <UnblurIcon />
                        Unblur
                      </div>
                    </BlurIndicator>
                  )}
                  {mediaItem.isBlurred && hasSubscription && (
                    <CrownIndicator>
                      <UnblurIcon />
                    </CrownIndicator>
                  )}
                </GalleryItem>
              );
            })}
          </GalleryGrid>
        )}
      </GalleryContainer>
    );
  };

  const renderDesktopContent = () => {
    switch (activeTab) {
      case CharacterTabs.ABOUT:
        return renderCharacterInfo();
      case CharacterTabs.GALLERY:
        return renderGallery();
      default:
        return null;
    }
  };

  return (
    <Container>
      {!isMobile && (
        <AvatarScroller onMouseDown={handleDragScroll}>
          {filteredCharacters.map((character, index) => (
            <AvatarWrapper
              key={index}
              onClick={() => {
                setActiveCharacter(character);
                setActiveTab(CharacterTabs.ABOUT);
              }}
              isActive={activeCharacter?.name === character.name}
            >
              <AvatarImage src={character.avatarsMap.default || void_ava} alt={character.name} />
              <CharacterName isActive={activeCharacter?.name === character.name}>
                {character.name}
              </CharacterName>
            </AvatarWrapper>
          ))}
        </AvatarScroller>
      )}

      {isMobile ? (
        <MobileFullScroll>

          <MobileFullContent>

            {activeCharacter && (
              <MobileImageWrapper>
                <MobileAvatarImage
                  src={activeCharacter?.cover?.mobile || void_ava}
                  alt={activeCharacter.name}
                />
              </MobileImageWrapper>
            )}

            {activeCharacter && filteredCharacters.length > 1 && (
              <MobileCharacterSelect>
                {filteredCharacters.map((character, index) => (
                  <MobileCharacterItem
                    key={index}
                    onClick={() => {
                      setActiveCharacter(character);
                    }}
                    isActive={activeCharacter?.name === character.name}
                  >
                    <MobileAvatarThumb src={character.avatarsMap.default || void_ava} alt={character.name} />
                    <MobileCharacterName>{character.name}</MobileCharacterName>
                  </MobileCharacterItem>
                ))}
              </MobileCharacterSelect>
            )}

            {hasPublicInfo(activeCharacter) && renderCharacterInfo()}

            {hasPublicInfo(activeCharacter) && hasGallery(activeCharacter, currentUser) &&
              <MobileSectionDivider />
            }

            {hasPublicInfo(activeCharacter) && hasGallery(activeCharacter, currentUser) &&
              <MobileGalleryLabel>Gallery</MobileGalleryLabel>
            }

            {hasGallery(activeCharacter, currentUser) && renderGallery()}
          </MobileFullContent>
        </MobileFullScroll>
      ) : (
        <>
          <NavigationBar>
            {hasPublicInfo(activeCharacter) && (
              <NavButton
                active={activeTab === CharacterTabs.ABOUT}
                onClick={() => setActiveTab(CharacterTabs.ABOUT)}
              >
                About
              </NavButton>
            )}
            {hasGallery(activeCharacter, currentUser) && (
              <NavButton
                active={activeTab === CharacterTabs.GALLERY}
                onClick={() => {
                  setActiveTab(CharacterTabs.GALLERY);
                  TrackingAPI.trackEvent('character_additional_info_gallery_click', analyticsData);
                }}
              >
                Gallery
              </NavButton>
            )}
          </NavigationBar>

          {renderDesktopContent()}
        </>
      )}

      {isVisiblePictureModal && <CarouselPictureModal onClose={() => setSelectedPhotoIndex(null)}><Carousel mediaItems={transformMediaItems(mediaItems)} initialIndex={selectedPhotoIndex!} /></CarouselPictureModal>}
    </Container >
  );
};

export default CharacterAdditionalInfo;

const Container = styled.div`
  margin-top: 20px;
  border-radius: 12px;
  background: #1d1d1d;
  margin-bottom: 20px;
  
  @media (max-width: 720px) {
    margin-top: 0;
    margin-bottom: 0;
    border-radius: 0;
    background: #1a1a1a;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
`;

const AvatarScroller = styled.div<{
  onMouseDown: (e: React.MouseEvent<HTMLDivElement>) => void;
  children: any;
}>`
  -bottom: 1rem;
  display: flex;
  border-radius: 12px 12px 0 0;
  overflow-x: auto;
  cursor: pointer;
  user-select: none;
  background: #131313;
  height: 90px;
  padding: 0 20px;

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  &:active {
    cursor: grabbing;
  }
  
  @media (max-width: 720px) {
    display: block;
    height: auto;
    padding: 0;
    gap: 0;
    justify-content: stretch;
    overflow: visible;
    background: transparent;
    border-radius: 0;
  }
`;

const AvatarWrapper = styled.div<{
  key: number;
  children: any;
  onClick: () => void;
  isActive: boolean;
}>`
  flex: 0 0 auto;
  width: 88px;
  height: 96px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  align-items: center;
  justify-content: center;
  background: ${props => (props.isActive ? '#1d1d1d' : '#131313')};
  
  @media (max-width: 720px) {
    width: 100%;
    height: 250px;
    padding: 0;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    border-radius: 0;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0) 60%);
      z-index: 1;
    }
  }
`;

const LoaderWrapper = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
`;

const AvatarImage = styled.img<{ src: string; alt: string }>`
  width: 54px;
  height: 54px;
  border-radius: 50%;
  object-fit: cover;
  pointer-events: none;
  -webkit-user-drag: none;
  user-select: none;
  
  @media (max-width: 720px) {
    width: 100%;
    height: 100%;
    border-radius: 0;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }
`;

const CharacterName = styled.div<{ isActive: boolean; children: any }>`
  font-family: 'Nunito Sans' !important;
  font-size: 14px;
  color: ${props => (props.isActive ? '#ffffff' : '#cccccc')};
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80%;
  
  @media (max-width: 720px) {
    font-size: 42px;
    max-width: 100%;
    width: 100%;
    padding: 20px 20px;
    margin: 0;
    text-align: center;
    font-weight: 400;
    color: white;
    position: absolute;
    bottom: 50px;
    left: 0;
    z-index: 2;
    white-space: normal;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);
  }
`;

const NavigationBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 8px 20px 0 20px;
  
  @media (max-width: 720px) {
    padding: 0;
    background: #1a1a1a;
    position: relative;
    z-index: 5;
  }
`;

const NavButton = styled.button<{ active?: boolean; children: any; onClick: () => void }>`
  color: ${props => (props.active ? '#ffffff' : '#696969')};
  transition: color 0.2s ease;
  height: 34px;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding: 0 18.5px;
  border-bottom: 1px solid ${props => (props.active ? '#FF7E55' : 'transparent')};

  font-family: 'Nunito Sans' !important;
  font-size: 16px;
  font-weight: 400;

  &:hover {
    color: ${props => (props.active ? '#ffffff' : '#CCCCCC')};
  }
  
  @media (max-width: 720px) {
    font-size: 18px;
    height: 42px;
    font-weight: ${props => (props.active ? '700' : '400')};
    flex-grow: 1;
    text-align: center;
    border-bottom: ${props => (props.active ? '3px solid #FF7E55' : '3px solid transparent')};
  }
`;

const GalleryContainer = styled.div`
  padding: 20px;
`;

const GalleryContainerWrapper = styled.div<{ hasVisibleMediaPacks: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 720px) {
    padding-bottom: ${props => props.hasVisibleMediaPacks ? '20px' : '0'};
  }
`;

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-top: 20px;
  
  @media (max-width: 720px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    width: 100%;
    overflow: visible;
    background: #1a1a1a;
    margin-top: 10px;
    max-height: none;
    min-height: auto;
  }
  
  @media (max-width: 430px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

const GalleryItem = styled.div<{ key: string; children: any; onClick: () => void }>`
  position: relative;
  aspect-ratio: 1;
  border-radius: 12px;
  background: #131313;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

const GalleryImage = styled.img<{ src: string; alt: string; draggable: string }>`
  object-position: top center;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
`;

const CharacterInfo = styled.div`
  padding: 20px;
  color: #fff;
  
  @media (max-width: 720px) {
    background: #1a1a1a;
    padding: 30px 20px;
    margin-top: 0;
    position: relative;
    z-index: 3;
    margin-bottom: 0;
    border-bottom: none;
  }
`;

const InfoRow = styled.div<{ hasScenarioMediaPacks?: boolean }>`
  display: flex;
  gap: 16px;
  margin-bottom: ${props => (props.hasScenarioMediaPacks ? '24px' : '16px')};
`;

const InfoItem = styled.div<{ fullWidth?: boolean; children: any }>`
  flex: ${props => (props.fullWidth ? '1 1 100%' : '1 1 50%')};
  display: flex;
  flex-direction: column;
  gap: 8px;

  align-items: flex-start;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
`;

const InfoLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #696969;

  font-family: 'Nunito Sans' !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

const InfoValue = styled.div`
  color: #fff;

  font-family: 'Nunito Sans' !important;
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

const VideoIndicator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  transition: background 0.2s ease;

  &::before {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 12px 0 12px 20px;
    border-color: transparent transparent transparent white;
    opacity: 0.8;
    transition: opacity 0.2s ease;
  }
`;

const BlurIndicator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  > div {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 15px 15px;
    height: 20px;
    background: linear-gradient(90deg, #9e5eee 0%, #b759ea 32%, #c65de9 66%, #b885f4 100%);
    border-radius: 15px;
    font-family: Nunito Sans;
    font-size: 10px;
    font-weight: 700;

    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    color: #ffffff;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

const CrownIndicator = styled.div`
  position: absolute;
  top: 15px;
  right: 10px;
  width: 25px;
  height: 25px;
  background: linear-gradient(90deg, #9e5eee 0%, #b759ea 32%, #c65de9 66%, #b885f4 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  svg {
    width: 16px;
    height: 16px;
  }
`;

// TODO: Выпилить отсюда свг
const UnblurIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none">
    <path
      d="M1.25931 5.54811C1.10944 4.31854 0.959481 3.08897 0.80944 1.85939C0.802123 1.79897 0.809228 1.73717 0.829851 1.68186C0.850473 1.62655 0.883681 1.58024 0.925242 1.54882C0.966803 1.51741 1.01484 1.50231 1.06322 1.50545C1.11161 1.50859 1.15816 1.52983 1.19695 1.56646L2.59859 2.89243C2.63501 2.92691 2.67662 2.95165 2.72088 2.96514C2.76513 2.97863 2.81111 2.98058 2.85599 2.97089C2.90087 2.9612 2.94371 2.94006 2.98189 2.90876C3.02007 2.87747 3.05279 2.83667 3.07804 2.78888L4.24501 0.579757C4.27345 0.526072 4.31195 0.482065 4.3571 0.45163C4.40225 0.421196 4.45265 0.405273 4.50384 0.405273C4.55503 0.405273 4.60543 0.421196 4.65057 0.45163C4.69572 0.482065 4.73422 0.526072 4.76267 0.579757L5.92963 2.78764C5.95489 2.83543 5.98761 2.87622 6.02579 2.90752C6.06397 2.93881 6.10681 2.95995 6.15169 2.96965C6.19656 2.97934 6.24254 2.97738 6.2868 2.96389C6.33106 2.9504 6.37267 2.92566 6.40909 2.89119L7.81073 1.56522C7.84951 1.52858 7.89606 1.50734 7.94445 1.5042C7.99284 1.50106 8.04087 1.51616 8.08243 1.54758C8.12399 1.579 8.1572 1.62531 8.17782 1.68062C8.19845 1.73593 8.20555 1.79773 8.19823 1.85815C8.04819 3.08772 7.89824 4.31729 7.74836 5.54687L1.25931 5.54811Z"
      fill="white"
    />
    <path
      d="M1.25879 6.23047H7.74833V7.16804C7.74833 7.22411 7.73957 7.27963 7.72256 7.33143C7.70555 7.38323 7.68062 7.4303 7.6492 7.46995C7.61777 7.50959 7.58046 7.54104 7.53939 7.5625C7.49833 7.58396 7.45432 7.595 7.40987 7.595H1.59724C1.50748 7.595 1.42139 7.55002 1.35792 7.46995C1.29445 7.38988 1.25879 7.28128 1.25879 7.16804V6.23047Z"
      fill="white"
    />
  </svg>
);

const UserIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.97631 10.3098C3.60143 9.68469 4.44928 9.3335 5.33333 9.3335H10.6667C11.5507 9.3335 12.3986 9.68469 13.0237 10.3098C13.6488 10.9349 14 11.7828 14 12.6668V14.0002C14 14.3684 13.7015 14.6668 13.3333 14.6668C12.9651 14.6668 12.6667 14.3684 12.6667 14.0002V12.6668C12.6667 12.1364 12.456 11.6277 12.0809 11.2526C11.7058 10.8775 11.1971 10.6668 10.6667 10.6668H5.33333C4.8029 10.6668 4.29419 10.8775 3.91912 11.2526C3.54405 11.6277 3.33333 12.1364 3.33333 12.6668V14.0002C3.33333 14.3684 3.03486 14.6668 2.66667 14.6668C2.29848 14.6668 2 14.3684 2 14.0002V12.6668C2 11.7828 2.35119 10.9349 2.97631 10.3098Z"
      fill="#696969"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00033 2.66683C6.89576 2.66683 6.00033 3.56226 6.00033 4.66683C6.00033 5.7714 6.89576 6.66683 8.00033 6.66683C9.10489 6.66683 10.0003 5.7714 10.0003 4.66683C10.0003 3.56226 9.10489 2.66683 8.00033 2.66683ZM4.66699 4.66683C4.66699 2.82588 6.15938 1.3335 8.00033 1.3335C9.84127 1.3335 11.3337 2.82588 11.3337 4.66683C11.3337 6.50778 9.84127 8.00016 8.00033 8.00016C6.15938 8.00016 4.66699 6.50778 4.66699 4.66683Z"
      fill="#696969"
    />
  </svg>
);

const AgeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
    <path
      d="M1.60039 13.3996C1.27039 13.3996 0.98789 13.2802 0.75289 13.0413C0.517891 12.8024 0.400391 12.5218 0.400391 12.1996V3.39961C0.400391 3.07739 0.517891 2.79683 0.75289 2.55794C0.98789 2.31905 1.27039 2.19961 1.60039 2.19961H2.80039V0.599609H4.00039V2.19961H8.00039V0.599609H9.20039V2.19961H10.4004C10.7304 2.19961 11.0129 2.31905 11.2479 2.55794C11.4829 2.79683 11.6004 3.07739 11.6004 3.39961V12.1996C11.6004 12.5218 11.4829 12.8024 11.2479 13.0413C11.0129 13.2802 10.7304 13.3996 10.4004 13.3996H1.60039ZM1.60039 12.1996H10.4004V6.19961H1.60039V12.1996ZM1.60039 4.99961H10.4004V3.39961H1.60039V4.99961Z"
      fill="#696969"
    />
  </svg>
);

const GenderIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
    <path
      d="M1.60039 13.3996V8.59961H0.400391V5.39961C0.400391 5.06961 0.517891 4.78711 0.75289 4.55211C0.98789 4.31711 1.27039 4.19961 1.60039 4.19961H4.00039C4.33039 4.19961 4.61289 4.31711 4.84789 4.55211C5.08289 4.78711 5.20039 5.06961 5.20039 5.39961V8.59961H4.00039V13.3996H1.60039ZM2.79622 3.39961C2.41011 3.39961 2.08095 3.26211 1.80872 2.98711C1.5365 2.71211 1.40039 2.38155 1.40039 1.99544C1.40039 1.60933 1.53789 1.28016 1.81289 1.00794C2.08789 0.73572 2.41845 0.599609 2.80456 0.599609C3.19067 0.599609 3.51983 0.737109 3.79206 1.01211C4.06428 1.28711 4.20039 1.61767 4.20039 2.00378C4.20039 2.38989 4.06289 2.71905 3.78789 2.99128C3.51289 3.2635 3.18233 3.39961 2.79622 3.39961ZM8.00039 13.3996V10.1996H6.00039L7.75039 4.96628C7.82817 4.74405 7.96261 4.56072 8.15372 4.41628C8.34483 4.27183 8.56039 4.19961 8.80039 4.19961C9.04039 4.19961 9.25595 4.27183 9.44706 4.41628C9.63817 4.56072 9.77261 4.74405 9.85039 4.96628L11.6004 10.1996H9.60039V13.3996H8.00039ZM8.79622 3.39961C8.41011 3.39961 8.08095 3.26211 7.80872 2.98711C7.5365 2.71211 7.40039 2.38155 7.40039 1.99544C7.40039 1.60933 7.53789 1.28016 7.81289 1.00794C8.08789 0.73572 8.41845 0.599609 8.80456 0.599609C9.19067 0.599609 9.51983 0.737109 9.79206 1.01211C10.0643 1.28711 10.2004 1.61767 10.2004 2.00378C10.2004 2.38989 10.0629 2.71905 9.78789 2.99128C9.51289 3.2635 9.18233 3.39961 8.79622 3.39961Z"
      fill="#696969"
    />
  </svg>
);

const PersonalityIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
    <path
      d="M2.40039 13.3996V10.4829C1.76706 9.94961 1.27539 9.30755 0.925391 8.55678C0.575391 7.806 0.400391 7.01472 0.400391 6.18294C0.400391 4.63205 0.946446 3.31378 2.03856 2.22811C3.13067 1.14244 4.45683 0.599609 6.01706 0.599609C7.22817 0.599609 8.31706 0.924609 9.28372 1.57461C10.2504 2.22461 10.8893 3.07183 11.2004 4.11628L12.3004 7.83294C12.3559 8.02717 12.3254 8.2035 12.2087 8.36194C12.0921 8.52039 11.9337 8.59961 11.7337 8.59961H10.8004V10.5996C10.8004 10.9296 10.6829 11.2121 10.4479 11.4471C10.2129 11.6821 9.93039 11.7996 9.60039 11.7996H8.00039V13.3996H6.80039V10.5996H9.60039V7.39961H10.9337L10.0671 4.51628C9.82261 3.71628 9.32539 3.0635 8.57539 2.55794C7.82539 2.05239 6.97261 1.79961 6.01706 1.79961C4.78372 1.79961 3.73928 2.22533 2.88372 3.07678C2.02817 3.92822 1.60039 4.96361 1.60039 6.18294C1.60039 6.83772 1.73928 7.45972 2.01706 8.04894C2.29483 8.63828 2.68372 9.14405 3.18372 9.56628L3.60039 9.93294V13.3996H2.40039ZM5.52256 8.59961H6.48372L6.55039 7.89961C6.67739 7.85717 6.79245 7.80767 6.89556 7.75111C6.99878 7.69455 7.10039 7.62183 7.20039 7.53294L7.83372 7.81628L8.31706 6.98294L7.76706 6.58294C7.78928 6.45517 7.80039 6.32739 7.80039 6.19961C7.80039 6.07183 7.78928 5.94405 7.76706 5.81628L8.31706 5.41628L7.83372 4.58294L7.20039 4.86628C7.1115 4.77739 7.0115 4.70516 6.90039 4.64961C6.78928 4.59405 6.67261 4.54405 6.55039 4.49961L6.47822 3.79961H5.51706L5.45039 4.49961C5.32339 4.54205 5.20833 4.59155 5.10522 4.64811C5.002 4.70466 4.90039 4.77739 4.80039 4.86628L4.16706 4.58294L3.68372 5.41628L4.23372 5.81628C4.2115 5.94405 4.20039 6.07183 4.20039 6.19961C4.20039 6.32739 4.2115 6.45517 4.23372 6.58294L3.68372 6.98294L4.16706 7.81628L4.80039 7.53294C4.88928 7.62183 4.98928 7.69405 5.10039 7.74961C5.2115 7.80517 5.32817 7.85517 5.45039 7.89961L5.52256 8.59961ZM6.00039 6.99961C5.77817 6.99961 5.58928 6.92183 5.43372 6.76628C5.27817 6.61072 5.20039 6.42183 5.20039 6.19961C5.20039 5.97739 5.27817 5.7885 5.43372 5.63294C5.58928 5.47739 5.77817 5.39961 6.00039 5.39961C6.22261 5.39961 6.4115 5.47739 6.56706 5.63294C6.72261 5.7885 6.80039 5.97739 6.80039 6.19961C6.80039 6.42183 6.72261 6.61072 6.56706 6.76628C6.4115 6.92183 6.22261 6.99961 6.00039 6.99961Z"
      fill="#696969"
    />
  </svg>
);

const MobileCharacterSelect = styled.div`
  display: flex;
  overflow-x: auto;
  padding: 10px 20px;
  background: #222222;
  scrollbar-width: none;
  -ms-overflow-style: none;
  
  &::-webkit-scrollbar {
    display: none;
  }
`;

const MobileCharacterItem = styled.div<{ isActive: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  min-width: 70px;
  opacity: ${props => (props.isActive ? 1 : 0.7)};
  cursor: pointer;
  
  &:hover {
    opacity: 1;
  }
`;

const MobileAvatarThumb = styled.img`
  width: 45px;
  height: 45px;
  border-radius: 50%;
  object-fit: cover;
`;

const MobileCharacterName = styled.div`
  font-family: 'Nunito Sans' !important;
  font-size: 12px;
  color: #ffffff;
  margin-top: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70px;
  text-align: center;
`;

const MobileGalleryLabel = styled.div`
  color: white;
  font-family: 'Nunito Sans' !important;
  font-size: 18px;
  font-weight: 400;
  margin: 20px 20px 10px 20px;
  
  @media (max-width: 720px) {
    margin: 25px 0 0 20px;
    font-size: 14px;
    font-weight: 400;
    color: #696969;
    line-height: 16px;
    letter-spacing: 0%;
    width: 46px;
    height: 16px;
  }
`;

const MobileSectionDivider = styled.div`
  height: 10px;
  background: #111111;
  width: 100%;
  margin: 0;
  
  @media (max-width: 720px) {
    display: block;
  }
  
  @media (min-width: 721px) {
    display: none;
  }
`;


const MobileFullScroll = styled.div`
  @media (max-width: 720px) {
    height: 100%;
    width: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
    display: block;
  }
`;

const MobileFullContent = styled.div`
  @media (max-width: 720px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-bottom: 150px;
    min-height: fit-content;
  }
`;

const MobileImageWrapper = styled.div`
  @media (max-width: 720px) {
    width: 100%;
    height: 250px;
    position: relative;
    overflow: hidden;
  }
`;

const MobileAvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: ${props => props.src === void_ava ? 'contain' : 'cover'};
  object-position: ${props => props.src === void_ava ? 'center' : 'top'};
`;
